module.exports = __webpack_public_path__ + "static/media/june 2.ef54059c.png";